import { motion } from "framer-motion";
import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export default function ToolTipNavItem({
  children,
  tooltipText = "",
  direction = "right",
}: {
  children?: React.ReactNode;
  tooltipText: string;
  direction?: "top" | "right" | "bottom" | "left";
}) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>{children}</TooltipTrigger>
        <TooltipContent side={direction} className="border-0">
          {direction == "right" && (
            <motion.div
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: "0", opacity: 1 }}
            >
              <p>{tooltipText}</p>
            </motion.div>
          )}

          {direction == "bottom" && (
            <motion.div
              initial={{ y: "-100%", opacity: 0 }}
              animate={{ y: "0", opacity: 1 }}
            >
              <p>{tooltipText}</p>
            </motion.div>
          )}

          {direction == "top" && (
            <motion.div
              initial={{ y: "100%", opacity: 0 }}
              animate={{ y: "0", opacity: 1 }}
            >
              <p>{tooltipText}</p>
            </motion.div>
          )}

          {direction == "left" && (
            <motion.div
              initial={{ x: "100%", opacity: 0 }}
              animate={{ x: "0", opacity: 1 }}
            >
              <p>{tooltipText}</p>
            </motion.div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
